import React from 'react'
import styled from 'styled-components'
import Knob from './Knob'
import shadowImg from '../static/images/backgrounds/shadow.png'
import { media } from '../styles/vars'

const Container = styled.div`
max-width:270px;
margin:0 auto;
position:relative;
z-index:1;
${media.desktop`
max-width:400px;
`}
`
const KnobsContainer = styled.div`
z-index:1;
display:flex;
justify-content:space-between;
align-items:center;
`
const Fade = styled.div`
position:absolute;
left:0;
right:0;
top:0;
bottom:0;
background-image:url(${shadowImg});
background-position:center;
background-size:cover;
opacity:.5;
`
const Knobs = (props) => (
    <Container>
        <Fade />
        <KnobsContainer>
            <Knob />
            <Knob
                big
                onKnobClick={props.onKnobClick}
                active={props.knobActive}
            />
            <Knob />
        </KnobsContainer>
    </Container>
);


export default Knobs;


// WEBPACK FOOTER //
// ./src/components/Knobs.jsx